<template>
    <div class="roadblock">
        <div class="blitz-content animated slideInUp">
            <h1>High Activity Alert</h1>
            <p>Seemingly related ORC incidents are increasing throughout the district. API investigators decide to partner with MAPMs to execute a district-wide blitz.</p>
        </div>
        <router-link to="/blitz-video">
            <NextButton />
        </router-link>
    </div>
</template>

<script>
import NextButton from '@/components/NextButton.vue'

export default {
  name: 'blitz',
  components: {
    NextButton
  },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>
.roadblock {
    background: url("~@/assets/roadblock-bg.jpg") center center no-repeat;
    background-size: cover;
    height: 100%;
    width: 100%;
}

.blitz-content {
    text-align: left;
    background: url("~@/assets/high-activity-modal.png") center center no-repeat;
    background-size: cover;
    width: 470px;
    height: 310px;
    position: absolute;
    top: 40px;
    left: 105px;
}

h1 { 
    color: #fff;
    padding: 57px 0 0 112px;
    font-size: 30px;
}
p {
    color: #4A4A4A;
    padding: 0 20px 0 235px;
    font-size: 19px;
}
</style>
